/**
 * ch-tracking.js — Chase Hub order tracking (sci-fi edition)
 * Uses XHR to bypass Shopify WPM fetch wrapping and QUIC issues.
 */
(function () {
  'use strict';

  var PROXY_URL = 'https://api.panel.whatexify.com/api/track/admin-e3861a';

  var form    = document.getElementById('ch-track-form');
  var input   = document.getElementById('ch-track-input');
  var result  = document.getElementById('ch-track-result');
  var loading = document.getElementById('ch-track-loading');
  var error   = document.getElementById('ch-track-error');
  if (!form) return;

  /* ── Status resolver (keyword-based — handles all Postex strings) ── */
  function resolveStatus(raw) {
    var s = (raw || '').toLowerCase();
    if (s.includes('cancel'))                                        return { step:-1, label: raw, icon:'✕' };
    if (s.includes('return'))                                        return { step:-1, label: raw, icon:'↺' };
    // Step 5: Delivered
    if (s.includes('delivered') && !s.includes('out for'))           return { step: 5, label: raw, icon:'✦' };
    // Step 4: Out for delivery / attempted
    if (s.includes('out for delivery') || s.includes('out for del')) return { step: 4, label: raw, icon:'◆' };
    if (s.includes('attempt'))                                       return { step: 4, label: raw, icon:'◇' };
    // Warehouse / hub: Multan = origin hub (step 1), any other city = in transit (step 2)
    if (s.includes('postex') || s.includes('warehouse') ||
        s.includes('hub') || s.includes('arrived') ||
        s.includes('received at')) {
      return s.includes('multan')
        ? { step: 1, label: raw, icon:'◎' }
        : { step: 2, label: raw, icon:'◈' };
    }
    // Step 2: En-Route
    if (s.includes('en-route') || s.includes('en route') ||
        s.includes('in transit') || s.includes('transit'))           return { step: 2, label: raw, icon:'◈' };
    // Step 1: Courier collected
    if (s.includes('picked') || s.includes('collected') ||
        s.includes('dispatched') || s.includes('shipped'))           return { step: 1, label: raw, icon:'◎' };
    // Step 0: Booked/Created
    return { step: 0, label: raw || 'CREATED', icon:'◉' };
  }

  var STEPS = [
    { label:'CREATED',        icon:'◉' },
    { label:'PICKED UP',      icon:'◎' },
    { label:'IN TRANSIT',     icon:'◈' },
    { label:'AT DESTINATION', icon:'⊡' },
    { label:'OUT FOR DEL.',   icon:'◆' },
    { label:'DELIVERED',      icon:'✦' },
  ];

  function show(el)  { el && el.classList.add('ch-visible'); }
  function hide(el)  { el && el.classList.remove('ch-visible'); }

  function esc(s) {
    return String(s == null ? '—' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function fmt(str) {
    if (!str) return '—';
    try {
      var d = new Date(str);
      return d.toLocaleDateString('en-PK',{day:'numeric',month:'short',year:'numeric'})
           + ' · ' + d.toLocaleTimeString('en-PK',{hour:'2-digit',minute:'2-digit'});
    } catch(e) { return str; }
  }

  /* ── Render result ─────────────────────────────────────────── */
  function render(d) {
    var info = resolveStatus(d.status);
    var step = info.step;

    var badge = document.getElementById('ch-track-badge');
    if (badge) {
      badge.innerHTML = '<span class="ch-track-badge__dot"></span>'
                      + '<span class="ch-track-badge__icon">' + info.icon + '</span>'
                      + '<span class="ch-track-badge__text">' + esc(info.label) + '</span>';
    }

    var elCn  = document.getElementById('ch-track-cn');
    var elCust = document.getElementById('ch-track-cust');
    if (elCn)   elCn.textContent   = 'CN: ' + (d.trackingNumber || '—');
    if (elCust) elCust.textContent = d.customerName || '—';

    var pct = step < 0 ? 0 : Math.round((step / 5) * 100);
    var fill = document.getElementById('ch-progress-fill');
    var trk  = document.getElementById('ch-progress-truck');
    if (fill) fill.style.width = pct + '%';
    if (trk)  trk.style.left  = 'calc(' + pct + '% - 20px)';

    var tl = document.getElementById('ch-timeline');
    if (tl) {
      tl.innerHTML = STEPS.map(function(s, i) {
        var cls = i < step ? 'done' : (i === step ? 'done active' : '');
        return '<div class="ch-tl-step ' + cls + '">'
          + '<div class="ch-tl-dot">' + s.icon + '</div>'
          + '<div class="ch-tl-label">' + s.label + '</div>'
          + '</div>';
      }).join('');
    }

    var rows = [
      ['TRACKING NO.', esc(d.trackingNumber)],
      ['COURIER',      esc(d.courier || d.courierKey || '—')],
      ['STATUS',       esc(d.status || '—')],
    ];
    var term = document.getElementById('ch-track-terminal');
    if (term) {
      var rowsHtml = rows.map(function(r) {
        return '<div class="ch-term-row">'
          + '<span class="ch-term-key">' + r[0] + '</span>'
          + '<span class="ch-term-val">' + r[1] + '</span>'
          + '</div>';
      }).join('');

      /* History events from new API */
      if (d.history && d.history.length) {
        rowsHtml += '<div class="ch-term-row ch-term-divider"><span class="ch-term-key">HISTORY</span></div>';
        var hist = d.history.slice().reverse();
        rowsHtml += hist.map(function(h) {
          return '<div class="ch-term-row">'
            + '<span class="ch-term-key">' + esc(fmt(h.at)) + '</span>'
            + '<span class="ch-term-val">' + esc(h.label) + '</span>'
            + '</div>';
        }).join('');
      }

      term.innerHTML = rowsHtml;
    }

    hide(loading);
    result && result.classList.add('ch-visible');

    if (typeof anime !== 'undefined') {
      anime.set('.ch-term-row', { opacity: 0, translateX: -10 });
      anime({ targets: '.ch-term-row', opacity: 1, translateX: 0,
        duration: 300, delay: anime.stagger(60), easing: 'easeOutQuad' });
    }
  }

  /* ── XHR fetch — bypasses WPM; retries once after QUIC failure ── */
  function trackXHR(cn, isRetry) {
    if (!isRetry) { hide(result); hide(error); show(loading); }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', PROXY_URL + '?cn=' + encodeURIComponent(cn), true);
    xhr.timeout = 10000;

    xhr.onload = function() {
      try {
        var data = JSON.parse(xhr.responseText);
        if (xhr.status >= 200 && xhr.status < 300) {
          render(data);
        } else {
          showError(data.error || 'Tracking number not found.');
        }
      } catch(e) {
        showError('Could not parse tracking response. Try again.');
      }
    };

    xhr.onerror = function() {
      if (!isRetry) {
        /* First failure likely broke Chrome's QUIC cache for this host.
           Retry immediately — browser will fall back to HTTP/2. */
        setTimeout(function() { trackXHR(cn, true); }, 300);
      } else {
        showError('Could not reach tracking service. Check your connection.');
      }
    };

    xhr.ontimeout = function() {
      showError('Request timed out. Please try again.');
    };

    xhr.send();
  }

  function showError(msg) {
    hide(loading);
    if (error) { error.textContent = '⚠ ' + msg; show(error); }
  }

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    var cn = (input ? input.value : '').trim().toUpperCase();
    if (!cn) return;
    if (!/^[A-Z0-9\-]{4,30}$/.test(cn)) {
      if (error) { error.textContent = '⚠ Invalid tracking number format.'; show(error); }
      return;
    }
    trackXHR(cn, false);
  });

})();
